import * as Yup from "yup";

// Re-usable “nullable date” that turns "" or invalid into null
const nullableDate = () =>
  Yup.date()
    .transform((value, originalValue) => {
      // if user gave us a real Date object, keep it
      if (value instanceof Date && !isNaN(value)) {
        return value;
      }
      // if they passed "" or null/undefined, we want null
      if (originalValue === "" || originalValue == null) {
        return null;
      }
      // otherwise try to parse it
      const parsed = new Date(originalValue);
      return isNaN(parsed) ? null : parsed;
    })
    .nullable();

export const vehicleSchema = Yup.object().shape({
  // ─── Core CSV / admin fields ─────────────────────────────────────────
  registration: Yup.string().required("Registration is required"),
  plate: Yup.string().optional(),
  group: Yup.string().optional(),
  modelDescription: Yup.string().optional(),
  regDate: nullableDate(),
  extras: Yup.string().optional(),
  estP11D: Yup.number().positive("Must be positive").nullable(),
  co2: Yup.number().integer().min(0, "Can't be negative").nullable(),
  color: Yup.string().optional(),
  mileage: Yup.number().min(0, "Can't be negative").required(),
  status: Yup.string()
    .oneOf(["draft", "available", "reserved", "sold"])
    .required("Status is required"),

  // ─── Interior Features ──────────────────────────────────────────────
  interiorFeatures: Yup.array()
    .of(
      Yup.object({
        category: Yup.string().min(1, "Category is required"),
        features: Yup.array()
          .of(Yup.string().min(1, "Feature cannot be empty"))
          .min(1, "Add at least one feature"),
      })
    )
    .default([]),

  // ─── VehicleSmart data ──────────────────────────────────────────────
  vehicleSmartData: Yup.object({
    vehicleDetails: Yup.object({
      dvlaCached: nullableDate(),
      co2Emissions: Yup.string().optional(),
      vehicleTypeApproval: Yup.string().optional(),
      cylinderCapacity: Yup.number().nullable(),
      fuel: Yup.string().optional(),
      year: Yup.number().nullable(),
      dateOfRegistration: nullableDate(),
      make: Yup.string().optional(),
      exportMarker: Yup.string().optional(),
      taxed: Yup.boolean().default(false),
      taxDueDate: nullableDate(),
      isSorn: Yup.boolean().default(false),
      colour: Yup.string().optional(),
      wheelplan: Yup.string().optional(),
      revenueWeight: Yup.number().nullable(),
      rawDvlaMotStatus: Yup.string().optional(),
      motd: Yup.boolean().default(false),
      motExpiryDate: nullableDate(),
      lastV5CIssued: nullableDate(),
      co2EmissionsIndex: Yup.number().nullable(),
      dvlaResults: Yup.boolean().default(false),
      dvsaResults: Yup.boolean().default(false),
      makeDvsa: Yup.string().optional(),
      modelDvsa: Yup.string().optional(),
      firstUsedDateDvsa: nullableDate(),
      dateOfRegistrationDvsa: nullableDate(),
      motExpiryDateDvsa: nullableDate(),
      fuelDvsa: Yup.string().optional(),
      colourDvsa: Yup.string().optional(),
      manufactureDateDvsa: nullableDate(),
      motdDvsa: Yup.boolean().default(false),
      hasOutstandingRecall: Yup.string().optional(),
      hasOutstandingRecallExplanation: Yup.string().optional(),
      dateOfRegistrationSource: Yup.string().optional(),
    }).required("Vehicle details are required"),

    calculatedTax: Yup.object({
      title: Yup.string().optional(),
      subtitle: Yup.string().optional(),
      taxDate: nullableDate(),
    }).required("Calculated tax is required"),

    calculatedMot: Yup.object({
      title: Yup.string().optional(),
      subtitle: Yup.string().optional(),
      validMot: Yup.boolean().default(false),
      motDateString: Yup.string().optional(),
      passedAnMot: Yup.boolean().default(false),
      motDaysLeft: Yup.string().optional(),
      motDate: nullableDate(),
    }).required("Calculated MOT is required"),

    vehicleMotData: Yup.array()
      .of(
        Yup.object({
          testDate: nullableDate(),
          odometer: Yup.number().nullable(),
          testResult: Yup.boolean().required("Pass/Fail required"),
          advisoryNoticeItems: Yup.array().of(Yup.string()).nullable(),
          reasonsForFailure: Yup.array().of(Yup.string()).nullable(),
        })
      )
      .default([]),
  }).required("VehicleSmartData is required"),
});

// src/schemas/vehicleSchema.js
// import * as Yup from "yup";

// export const vehicleSchema = Yup.object({
//   registration: Yup.string().required("Registration is required"),
//   plate: Yup.string().optional(),
//   vin: Yup.string().optional(),
//   make: Yup.string().optional(),
//   model: Yup.string().optional(),
//   year: Yup.number()
//     .min(1886, "Year looks too early")
//     .max(new Date().getFullYear() + 1, "Year looks too late")
//     .notRequired(),
//   price: Yup.number().positive("Must be positive").notRequired(),
//   mileage: Yup.number().min(0, "Can't be negative").default(0),
//   color: Yup.string().optional(),
//   group: Yup.string().optional(),
//   modelDescription: Yup.string().optional(),
//   regDate: Yup.date().nullable(),
//   extras: Yup.string().optional(),
//   estP11D: Yup.number().positive().nullable(),
//   co2: Yup.number().integer().min(0).nullable(),
//   status: Yup.string()
//     .oneOf(["draft", "available", "reserved", "sold"])
//     .default("draft"),

//   interiorFeatures: Yup.array()
//     .of(
//       Yup.object({
//         category: Yup.string().min(1, "Category is required"),
//         features: Yup.array()
//           .of(Yup.string().min(1, "Feature cannot be empty"))
//           .min(1, "Add at least one feature"),
//       })
//     )
//     .notRequired()
//     .default([]),
// });
